/* eslint-disable react/jsx-no-target-blank */
import { FC } from "react";
import {Link, useLocation} from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { SiteLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";
import { FAX_NUMBER, PHONE_NUMBER } from "src/constants/contact";



const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="navbar navbar-expand-lg guest-nav">
      <div className="container container-full flex-fill">
        {location.pathname === "/enroll" ? (
            <span role="button" className="navbar-brand"><img src={SiteLogo} alt="Site logo" /></span>
        ) : (
            <Link className="navbar-brand" to="/users/sign_in"><img src={SiteLogo} alt="Site logo" /></Link>
        )}
        {location.pathname !== "/enroll" &&
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
              <span className="navbar-toggler-icon"></span>
            </button>
        }
        {location.pathname !== "/enroll" &&
            <div className="collapse navbar-collapse justify-content-end" id="hubHeader">
              <ul className="navbar-nav">
                {PublicHeader.map((headerLink, index) => (
                    <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`} key={index}>
                      {headerLink.actionType === HeaderElementType.ROUTE ? (
                          <Link className="nav-link px-2 py-1" aria-current="page" to={headerLink.redirectLink}>{headerLink.title}</Link>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.BUTTON ? (
                          <button className="btn btn-warning rounded-pill" onClick={() => { navigate(headerLink.redirectLink) }}>
                            {headerLink.title}
                          </button>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.LINK ? (
                          // eslint-disable-next-line react/jsx-no-target-blank
                          <a className="nav-link px-2 py-1" href={headerLink.redirectLink} target="_blank">
                            {headerLink.title}
                          </a>
                      ) : null}
                      {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                          <>
                            <a className="nav-link px-2 py-1 dropdown-toggle" href="." data-bs-toggle="dropdown" aria-expanded="false">
                              {headerLink.title}
                            </a>
                            <ul className="dropdown-menu dropdown-menu-start" style={{ minWidth:'400px' }}>
                              {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                                  <li key={index}>
                                    <a className="dropdown-item" href={header.redirectLink} target="_blank">
                                      {header.title}
                                    </a>
                                  </li>
                              ))}
                            </ul>
                          </>
                      ) : null}
                    </li>
                ))}
                <li className={"text-start text-lg-end px-2 px-lg-0"}>
                  <p className="mb-1"><b className="text-primary">Phone:</b> 1-{PHONE_NUMBER}</p>
                  <p className="mb-1"><b className="text-primary">Fax:</b> 1-{FAX_NUMBER}</p>
                  <p><b className="text-primary">Visit:</b> QutenzaHCP.com</p>
                </li>
              </ul>
            </div>
        }
      </div>
    </nav>
  );
};

export default GuestHeader;
